import { CompanyType } from 'src/types/types'

export const getPersonalizedSender = (sender: string): CompanyType => {
  const hokGroup = [
    'Prisma Herttoniemi',
    'S-market Laajasalo',
    'Food Market Herkku',
    'S-market Ruoholahti',
    'S-market Itälahdenkatu',
    'Prisma Tripla',
    'S-market Arabia',
    'S-market Redi',
  ]

  if (hokGroup.includes(sender)) {
    return CompanyType.Hok
  } else if (sender === 'Foodora Market') {
    return CompanyType.FoodoraMarket
  } else if (sender === 'Ruokaboksi') {
    return CompanyType.Ruokaboksi
  } else {
    return null
  }
}

export default getPersonalizedSender
